export default __webpack_public_path__ + "static/media/Refresh.c109a917.png";